var _path, _path2, _rect, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99167 0C2.40845 0 1.125 1.28345 1.125 2.86667V15.1333C1.125 16.7165 2.40845 18 3.99167 18H14.0083C15.5915 18 16.875 16.7165 16.875 15.1333V2.86667C16.875 2.86257 16.875 2.85848 16.875 2.85439V5.29412L14.25 2.64706L11.625 0H3.99167Z",
    fill: "#45B058"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 5.375L11.5 5.375L11.5 -7.08316e-07L14.1875 2.6875L16.875 5.375Z",
    fill: "#A2D8AB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 5.375,
    width: 5.375,
    height: 0.5375,
    fill: "black",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.883 12.7618C2.883 14.1228 3.9924 15.129 5.2824 15.129C6.2757 15.129 7.2432 14.4324 7.5012 13.6261L6.74655 13.381C6.56595 13.9164 6.08865 14.3743 5.28885 14.3743C4.38585 14.3743 3.66345 13.7035 3.66345 12.7618C3.66345 11.704 4.36005 11.059 5.28885 11.059C6.01125 11.059 6.47565 11.5363 6.7272 12.0394L7.48185 11.8266C7.12065 10.9558 6.26925 10.3302 5.2824 10.3302C4.0311 10.3302 2.883 11.3493 2.883 12.7618Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4616 13.5745C8.58415 14.0905 8.9776 14.3872 9.3388 14.4324C9.829 14.4904 10.2353 14.2518 10.2676 13.8067C10.3127 13.3036 9.79675 13.065 8.9131 12.7747C8.3068 12.5748 7.90045 12.0652 7.9327 11.4976C7.9585 10.9945 8.3068 10.4785 8.9905 10.3237C9.6742 10.1689 10.5062 10.356 10.8674 11.2138L10.2095 11.517C9.99025 10.9687 9.50005 10.8591 9.06145 11.0332C8.6422 11.1945 8.63575 11.5105 8.68735 11.6847C8.7454 11.9298 9.0937 12.1039 9.33235 12.1813C10.403 12.5748 11.0029 12.8779 11.0222 13.7422C11.0416 14.6001 10.3837 15.0774 9.5323 15.1225C8.6809 15.1677 7.90045 14.6839 7.75855 13.8196L8.4616 13.5745Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.873 15.0322H13.6792L15.4143 10.4076H14.5758L13.2987 14.026L12.0087 10.4011H11.1508L12.873 15.0322Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.d7d4b14e4f35959c498e4e56f9173cac.svg";
export { ForwardRef as ReactComponent };